/**
 * The `isArray()` function determines whether the passed value is an `Array`.
 *
 * This uses the built-in `Array.isArray()` for validation, but unlike the built-in function, this function narrowly types
 * the value param to `unknown[]` instead of `any[]`.
 *
 * @param value - The value to be checked.
 * @returns `true` if value is an `Array`; otherwise, `false`. `false` is always returned if value is a `TypedArray` instance.
 */
export function isArray(value: unknown): value is unknown[] {
  return Array.isArray(value);
}
